import React from "react";
import Img from "gatsby-image";
import styled from "styled-components";
// import Seal from '../assets/images/mha.png';
import Breakpoints from "./styles/Breakpoints";
const Wrapper = styled.div`
  max-width: 755px;
  width: 100%;
  margin: 0 auto;

  display: flex;

  align-items: flex-end;
  position: relative;
`;

const Image = styled.div`
  max-width: ${(props) => props.w}%;
  width: 100%;

  > .gatsby-image-wrapper {
  }
`;

const SealImage = styled.img`
  position: absolute;

  top: 0;
  right: 10px;

  width: 65px;

  @media ${Breakpoints.tablet} {
    width: 100px;
    right: 25px;
  }
`;

export default function BundleImages({ images = [], selection }) {
  const totalSize = images.reduce(
    (acc, i) => acc + i.file.details.image.width,
    0
  );

  return (
    <Wrapper>
      {images.map((i) => (
        <Image w={Math.round((i.file.details.image.width / totalSize) * 100)}>
          <Img fluid={i.fluid} />
        </Image>
      ))}
      {/* <SealImage src={Seal} /> */}
    </Wrapper>
  );
}
